function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "a",
  d: "M15.49 9H9.5A1.5 1.5 0 0 0 8 10.5v18.017a1.5 1.5 0 0 0 1.5 1.5h13.49V23.986a3 3 0 0 1 3-3h8.975V10.5a1.5 1.5 0 0 0-1.5-1.5H27.49v5.486a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V9zm3 0v2.986h6V9h-6zm22.5 17.986v-3h-15v3h15zm0 3h-15v9h15v-9zm-18 3.031H9.5a4.5 4.5 0 0 1-4.5-4.5V10.5A4.5 4.5 0 0 1 9.5 6h23.965a4.5 4.5 0 0 1 4.5 4.5v10.486h3.025a3 3 0 0 1 3 3v15a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3v-5.969zm-10.5-6.031a1.5 1.5 0 1 1 0-3h3a1.5 1.5 0 0 1 0 3h-3zm18 9a1.5 1.5 0 1 1 0-3h6.04a1.5 1.5 0 0 1 0 3h-6.04z"
});

var SvgDate = function SvgDate(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default SvgDate;


//////////////////
// WEBPACK FOOTER
// ./src/icons/shipment-status/date.svg
// module id = 175
// module chunks = 0 1